import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import type { MouseEvent } from "react";

interface Props {
  isZoomed: boolean;
  onClick: (e?: MouseEvent) => void;
}

export default function ChartZoomResetButton({ isZoomed, onClick }: Props) {
  return (
    <button
      type="button"
      className={`chart-tool-btn${isZoomed ? " is-zoomed" : ""}`}
      title={isZoomed ? "Chart is zoomed — click to reset" : "Reset zoom"}
      aria-label={isZoomed ? "Chart is zoomed — reset zoom" : "Reset zoom"}
      aria-pressed={isZoomed}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <ZoomOutMapIcon fontSize="small" />
    </button>
  );
}
